import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  products: [],
  templates: [],
  skus: [],
};

const utilsSlice = createSlice({
  name: "utils",
  initialState,
  reducers: {
    setProducts: (state, action) => {
      state.products = action.payload;
    },
    setTemplates: (state, action) => {
      state.templates = action.payload;
    },

    setSkus: (state, action) => {
      state.skus = action.payload;
    },
  },
});

export const { setProducts, setTemplates,setSkus } = utilsSlice.actions;
export default utilsSlice.reducer;
